import React from 'react';
import { Formik, Form as FormikForm, Field, ErrorMessage } from 'formik';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { Spinner } from 'react-bootstrap';
import { ForgotPasswordValidationSchema } from 'utils/validationSchemas';
import { forgotPassword } from 'Api/userapi';

const ForgotPasswordForm = ({
  layout
}: {
  layout?: 'simple' | 'card' | 'split';
}) => {
  const navigate = useNavigate();

  const handleSubmit = async (
    values: { email: string },
    {
      setSubmitting,
      resetForm
    }: { setSubmitting: (isSubmitting: boolean) => void; resetForm: () => void }
  ) => {
    setSubmitting(true);
    try {
      const response = await forgotPassword(values.email);
      if (response.status === 200) {
        const message = response.data.message;
        toast.success(message);
        resetForm();
        setTimeout(() => {
          navigate('/sign-in');
        }, 2000);
      }
    } catch (error) {
      const message = 'Reset password link sent successfully.';
      toast.success(message);
      setTimeout(() => {
        resetForm();
        navigate('/notification');
      }, 2000);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <div className="text-center mb-4">
        <h4 className="text-body-highlight">Forgot your password?</h4>
        <p className="text-body-tertiary mb-5">
          Enter your email below and we will send <br className="d-sm-none" />
          you a reset link.
        </p>
      </div>
      <Formik
        initialValues={{ email: '' }}
        validationSchema={ForgotPasswordValidationSchema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting, touched, errors }) => (
          <FormikForm>
            <div className="d-flex flex-column align-items-start mb-2 ">
              <Field
                name="email"
                type="email"
                className={`form-control form-icon-input ${
                  touched.email && errors.email ? 'is-invalid' : ''
                }`}
                placeholder="Email"
              />

              <ErrorMessage
                name="email"
                component="div"
                className="text-danger mt-1 fs-9"
              />
            </div>

            <div className="d-flex justify-content-between align-items-center mb-4">
              <div>
                <span className="text-body-tertiary">
                  Remembered your password?
                </span>
                <Link
                  to="/sign-in"
                  className="text-primary text-decoration-none ms-1"
                >
                  Sign In
                </Link>
              </div>
            </div>

            <div className="text-center">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <Spinner animation="border" size="sm" role="status" />
                ) : (
                  <>Reset password</>
                )}
              </button>
            </div>
          </FormikForm>
        )}
      </Formik>

    </>
  );
};

export default ForgotPasswordForm;
